var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_background"},[_c('new-glas-card',{attrs:{"title":_vm.$t('templates_component.title')}},[_c('templates-component')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }